'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".Alert-module_container__hLoDT{animation-timing-function:ease-in-out}@keyframes Alert-module_fadeOut__Y-Kw2{0%{opacity:1}to{opacity:0}}.Alert-module_dismiss__t-w4F{float:right;margin:1rem}.Alert-module_alert__hwuIT{background-color:#fff;cursor:auto;padding:1.25rem}";
var styles = {"container":"Alert-module_container__hLoDT","dismiss":"Alert-module_dismiss__t-w4F","alert":"Alert-module_alert__hwuIT","fadeOut":"Alert-module_fadeOut__Y-Kw2"};
styleInject["default"](css_248z, '0ab6a67f-d0e7-405e-9c28-f5248626b685');

exports["default"] = styles;
